import { useQuery } from "@tanstack/react-query";

import { fetchDataGet } from "@/core/api/api-methods";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { kycEndpoints } from "@/features/kyc/api/endpoints";
import type { PartyDto } from "@/features/kyc/api/dto";

/** Détail d'une identité (`GET /Parties/{id}`). */
export const useParty = (partyId: string, enabled = true) =>
  useQuery({
    queryKey: QUERY_KEYS.KYC_PARTY_DETAIL(partyId),
    queryFn: () => fetchDataGet<PartyDto>({ url: kycEndpoints.parties.detail(partyId) }),
    retry: (failureCount, error) =>
      !/401/.test(error?.message ?? "") && failureCount < 1,
    enabled: enabled && Boolean(partyId),
  });
